import { DrawCabinetInsideElement } from './DrawCabinetInsideElement';

export class DrawInsideDoorRack extends DrawCabinetInsideElement {
    Number!: number;
}
